module.exports = __webpack_public_path__ + "img/nadneda_no.df8f70a6.png";